<template>
  <div :id="id" :class="className" :style="{ height: height, width: width }" />
</template>
<script>
import * as echarts from 'echarts';
import resize from "@/components/chart/mixins/resize";
const temp = ["补贴发放金额"];
import { parseTime } from "@/utils/index";
let chartVm = null;
export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    id: {
      type: String,
      default: "chart6",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    chartData: {
      type: Object,
    },
    unit: {
      type: String,
      default: "家",
    },
    jobTypeName: {
      type: String,
      default: "--",
    }
  },
  data() {
    return {
      chart: null,
      options: {
        tooltip: {
          position: function (pos, params, dom, rect, size) {
              // 鼠标在左侧时 tooltip 显示到右侧，鼠标在右侧时 tooltip 显示到左侧。
              let obj = {top: 60};
              // obj[['left', 'right'][+(pos[0] < size.viewSize[0] / 2)]] = 5;
              obj[['left', 'right'][+(pos[0] > size.viewSize[0] / 2)]] = 5;
              return obj;
          },
          trigger: "axis",
          borderColor: 'rgba(10, 69, 31, 0.8)',
          backgroundColor: 'rgba(10, 69, 31, 0.8)',
          axisPointer: {
            type: "line",
            lineStyle: {
              type: 'dashed',
              width: 1,
            },
            label: {
              color: '#ffffff',
              backgroundColor: "rgba(10, 69, 31, 0.8)",
            },
            axis: 'y'
          },
          formatter(params) {
            let dom = '';
            [params[0]].map(v=>{
              dom+= `
              <div style="font-size:14px;color:#fff;font-weight:400;line-height:1;margin-bottom: 10px">${v.axisValueLabel}</div>
              <div style="margin: 0px 0 0;line-height:1;display: flex;align-items: center;">
									<div style="margin: 0px 0 0;line-height:1;">
                    <span style="float:right;margin-left:20px;font-size:14px;color:#fff;font-weight:900;line-height: 18px;">${v.value || '0'}${chartVm.unit || '家'}</span>
									</div>
								</div>`
            });
            return `<div>${dom}</div>`;
          }
        },
        legend: {
          show: false,
          orient: "horizontal",
          x: "right",
          y: "10",
          data: ["补贴发放金额"],
          itemWidth: 10,
          itemHeight: 10,
          itemStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: "rgba(13, 255, 169, 1)", // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: "rgba(13, 255, 169, 0.3)", // 100% 处的颜色
                },
              ],
              global: false, // 缺省为 false
            },
          },
          textStyle: {
            color: "#FFFFFF",
            fontSize: "12",
          },
        },
        grid: {
          right: "10%",
          left: "30%",
          top: "38%",
          bottom: "12%"
        },
        xAxis: {
          type: "category",
          zlevel: 20,
          z: 10,
          // axisPointer: {
          //   type: 'none',
          // },
          axisTick: {
            //y轴刻度线
            show: false,
          },
          offset: -7,
          axisLabel: {
            interval: 0,
            color: '#FFFFFF',
            fontSize: 12,
            backgroundColor: 'rgba(0, 97, 56, 0.7)',
            padding: [8, 3, 2, 3],
            zlevel: 100,
            z: 100,
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#FFFFFF",
            },
            width: 1,
          },
          // axisLine: {
          //   lineStyle: {
          //     color: '#96A4F4'
          //   },
          //   width: 5
          // },

          data: [],
        },

        yAxis: {
          minInterval: 1,
          name: `单位（${this.unit || '家'}）`,
          type: "value",
          nameTextStyle: {
            color: '#FFFFFF',
            fontSize: 13,
            align: 'right',
            padding: [0, -16, 5, 0]
          },
          axisLabel: {
            interval: 0,
            color: '#FFFFFF',
            fontSize: 12,
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#FFFFFF",
            },
            width: 5,
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: "rgba(13, 255, 169, 0.1)",
            },
          },
        },
        series: [],
      },
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.initChart();
      },
    },
  },
  mounted() {
    this.initChart();
    chartVm = this;
  },
  created() {},
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    setChartData() {
      this.options.yAxis.name = `单位（${this.unit || '家'}）`;
      let series = [];
      let that = this;
      if (this.chartData.regionList) {
        // series.push(
        //   {
        //       // 最下面菱形
        //       data: this.chartData.valueList,
        //       type: 'pictorialBar',
        //       symbol: 'diamond',
        //       symbolSize: [20, 10],
        //       symbolPosition: 'start',
        //       symbolOffset: [0, 5],
        //       itemStyle: {
        //         color: function(params) {
        //           return that.chartData.colorArr[params.dataIndex][0] + '1)';
        //         }
        //       },
        //       z: 5,
        //       zlevel: 10,
        //     }
        // );
        // 为了实现立体效果，把两个柱子并在一起
        series.push({
          name: this.chartData.barName1,
          type: "bar",
          barGap: 0,
          barWidth: "10",
          label: {
            show: false,
            position: "insideLeft",
            formatter(v) {
              if (v.value) {
                return "";
              } else {
                return v.value;
              }
            },
          },
          itemStyle: {
            normal: {
              color: function(params) {
                return  new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1, //渐变色在下面修改，这里是透明度
                  [
                    {
                      offset: 0,
                      color: that.chartData.colorArr[params.dataIndex][0] + '1)',
                    },
                    {
                      offset: 1,
                      color: that.chartData.colorArr[params.dataIndex][1] + '1)',
                    },
                  ]
                );
              }
            },
          },
          data: this.chartData.valueList,
          z: 5,
          zlevel: 10,
        });
        series.push({
          name: this.chartData.barName1,
          type: "bar",
          barWidth: "10",
          barGap: 0,
          label: {
            show: false,
            position: "insideLeft",
            formatter(v) {
              if (v.value) {
                return "";
              } else {
                return v.value;
              }
            },
          },
          itemStyle: {
            normal: {
              color: function(params) {
                return new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1, //渐变色在下面修改，这里是透明度
                  [
                    {
                      offset: 0,
                      color: that.chartData.colorArr[params.dataIndex][0] + '0.8)',
                    },
                    {
                      offset: 1,
                      color: that.chartData.colorArr[params.dataIndex][1] + '0.8)',
                    },
                  ]
                );
              }
            },
          },
          data: this.chartData.valueList,
          z: 5,
          zlevel: 10,
        });
        series.push(
          {
              // 最下面菱形
              data: this.chartData.valueList,
              type: 'pictorialBar',
              symbol: 'diamond',
              symbolSize: [20, 10],
              symbolPosition: 'end',
              symbolOffset: [0, -5],
              itemStyle: {
                color: function(params) {
                  return that.chartData.colorArr[params.dataIndex][0] + '1)';
                }
              },
              z: 5
            }
        );


        // series.push({
        //   name: this.chartData.barName2,
        //   type: "bar",
        //   barGap: 0,
        //   barWidth: "10",
        //   label: {
        //     show: false,
        //     position: "insideLeft",
        //     formatter(v) {
        //       if (v.value) {
        //         return "";
        //       } else {
        //         return v.value;
        //       }
        //     },
        //   },
        //   itemStyle: {
        //     normal: {
        //       color: new echarts.graphic.LinearGradient(
        //         0,
        //         0,
        //         0,
        //         1, //渐变色在下面修改，这里是透明度
        //         [
        //           {
        //             offset: 0,
        //             color: "rgba(83, 255, 201, 1)",
        //           },
        //           {
        //             offset: 1,
        //             color: "rgba(6, 216, 131, 1)",
        //           },
        //         ]
        //       ),
        //     },
        //   },
        //   data: this.chartData.valueList2,
        //   z: 1,
        //   barCategoryGap: '20%' // 类别间柱子间距  
        // });
        // series.push({
        //   name: this.chartData.barName2,
        //   type: "bar",
        //   barWidth: "10",
        //   barGap: 0,
        //   label: {
        //     show: false,
        //     position: "insideLeft",
        //     formatter(v) {
        //       if (v.value) {
        //         return "";
        //       } else {
        //         return v.value;
        //       }
        //     },
        //   },
        //   itemStyle: {
        //     normal: {
        //       color: new echarts.graphic.LinearGradient(
        //         0,
        //         0,
        //         0,
        //         1, //渐变色在下面修改，这里是透明度
        //         [
        //           {
        //             offset: 0,
        //             color: "rgba(83, 255, 201, 0.8)",
        //           },
        //           {
        //             offset: 1,
        //             color: "rgba(6, 216, 131, 0.8)",
        //           },
        //         ]
        //       ),
        //     },
        //   },
        //   data: this.chartData.valueList2,
        //   z: 1,
        //   barCategoryGap: '20%' // 类别间柱子间距  
        // });
        // series.push(
        //   {
        //       // 最下面菱形
        //       data: this.chartData.valueList2,
        //       type: 'pictorialBar',
        //       symbol: 'diamond',
        //       symbolSize: [20, 10],
        //       symbolPosition: 'end',
        //       symbolOffset: [10, -5],
        //       itemStyle: {
        //         color: 'rgba(83, 255, 201, 1)',
        //       },
        //       z: 1,
        //       barCategoryGap: '20%' // 类别间柱子间距  
        //     }
        // );

        this.options.xAxis.data = this.chartData.regionList;
        this.options.series = series;
        this.chart.setOption(this.options);
      } else {
        this.options.xAxis.data = [];
        this.options.series = [];
        this.chart.setOption(this.options,true); // 设置为true的话，就是notMerge，不合并,false的话，就Merge，之前的东西还保留~
      }

    },
    initChart() {
      if (!this.chart) {
        this.chart = echarts.init(document.getElementById(this.id));
      }
      this.setChartData();
    },
  },
};
</script>
